import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "../../../components/Sidebar";
import { getHtmlPage } from "../../../utils/apiClient";
import AppConstants from "../../../utils/appConstants";
import "../../css/legalDocument.css";

export default function LegalDocumentPage({ documentKey, title }) {
  const { i18n, t } = useTranslation("mobile");
  const [user, setUser] = useState(null);
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      const storedUser = sessionStorage.getItem("userData");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (_) {}
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchContent = async () => {
      if (!documentKey) {
        setError("Document key is missing.");
        setLoading(false);
        return;
      }

      setLoading(true);
      setError("");

      try {
        const languageCode = (i18n.language || "en").split("-")[0].toLowerCase();
        const userId =
          user?.USER_ID ||
          user?.user_id ||
          user?.ID ||
          user?.id ||
          localStorage.getItem("userId") ||
          sessionStorage.getItem("userId");

        const response = await getHtmlPage(languageCode, documentKey, { userId });
        const data = response?.decryptedData || response?.data || {};
        const code = Number(data?.CODE);

        if (code === AppConstants.responseOk) {
          const content = data?.DATA || response?.htmlContent || "";
          if (!cancelled) {
            setHtmlContent(content);
          }
        } else if (!cancelled) {
          setError(data?.MESSAGE || "Failed to load legal document.");
        }
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || "Failed to load legal document.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchContent();

    return () => {
      cancelled = true;
    };
  }, [documentKey, i18n.language, user]);

  const resolvedTitle =
    documentKey === "privacy_policy"
      ? t("privacy_policy")
      : documentKey === "terms_of_services"
        ? t("terms_of_services")
        : documentKey === "risk_disclosure"
          ? t("risk_disclosure")
          : title;

  return (
    <div className="legal-document-page">
      <Sidebar user={user} />
      <div className="legal-document-content">
        <h1 className="legal-document-title">{resolvedTitle}</h1>

        <div className="legal-document-container">
          {loading ? (
            <div className="legal-document-loading">Loading...</div>
          ) : error ? (
            <div className="legal-document-error">{error}</div>
          ) : htmlContent ? (
            <div
              className="legal-document-html"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          ) : (
            <div className="legal-document-empty">No content available.</div>
          )}
        </div>
      </div>
    </div>
  );
}
